import React from 'react';
import BrandingIcon from '../images/branding_lt.png';
import styles from './container.module.scss';

export default function Container(props) {
  const { primaryText, secondaryText, children } = props;
  return (
    <div className={styles.background}>
      <div className={styles.frame}>
        <div className={styles.guide}>
          <img src={BrandingIcon} alt="" />
          <h1 className={styles.text}>{primaryText}</h1>
          <h2 className={styles.text}>{secondaryText}</h2>
        </div>
        <div className={styles.card}>{children}</div>
      </div>
    </div>
  );
}
